import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Packages
import { Button } from 'react-bootstrap';
import Axios from 'axios';
import PropTypes from 'prop-types';

// Components
import FieldsTable from './FieldsTable';
import ConfirmDialog from '../../../utils/ConfirmDialog';

// Actions
import { global_config_field_delete, set_global_config_group_id } from '../../../../actions/globalActions';

// Utils
import isEmpty from '../../../../utils/isEmpty';
import create_query_params from '../../../../utils/create_query_params';

const Fields = (props) => {
	const { groupId, filters, setShowFieldModal, setUpdate, setFieldToUpdate } = props;

	const dispatch = useDispatch();

	const { global_config_groups_changes } = useSelector(state => state.global);

	const [fieldsLoading, setFieldsLoading] = useState(true);
	const [fields, setFields] = useState({ count: 0, fields: [] });
	const [confirmDialog, setConfirmDialog] = useState({ show: false, title: '', function: null });

	useEffect(() => {
		if (!isEmpty(filters)) {
			const fieldFilters = {
				...filters,
				...(groupId && { group: groupId })
			};
			getFields(fieldFilters);
		}
	}, [filters]);

	useEffect(() => {
		if (global_config_groups_changes[groupId]) {
			const fieldFilters = {
				...filters,
				group: groupId
			};
			getFields(fieldFilters);
		}
	}, [global_config_groups_changes[groupId]]);

	const getFields = (params) => {
		Axios.get(process.env.REACT_APP_SERVER_URL + '/api/global/fields?' + create_query_params(params))
		.then((response) => {
			setFields(response.data);
			setFieldsLoading(false);
		})
		.catch(() => {
			setFieldsLoading(false);
		});
	}

	const createField = () => {
		setUpdate(false);
		setShowFieldModal(true);
		setFieldToUpdate({});
		dispatch(set_global_config_group_id(groupId));
	}

	const updateField = (field) => {
		setUpdate(true);
		setShowFieldModal(true);
		setFieldToUpdate(field);
		dispatch(set_global_config_group_id(groupId));
	}

	const deleteField = (fieldId) => {
		const fieldFilters = {
			...filters,
			...(groupId && { group: groupId })
		};
		setConfirmDialog({
			show: true,
			title: 'delete this field',
			function: () => dispatch(global_config_field_delete(fieldId, () => getFields(fieldFilters)))
		});
	}

	return (
		<div>
			<ConfirmDialog
				show={confirmDialog.show}
				confirmDialogTitle={confirmDialog.title}
				onHide={() => setConfirmDialog({ ...confirmDialog, show: false })}
				confirmFunction={confirmDialog.function}
			/>

			{groupId && <hr />}
			{fields.count > 0 &&
				<div>
					<h5 className='text-center'>Fields</h5>
					<FieldsTable
						tableLoading={fieldsLoading}
						tableData={fields.fields}
						updateField={updateField}
						deleteField={deleteField}
					/>
				</div>
			}
			{groupId && 
				<div className='d-grid gap-2'>
					<Button className='simple-btn' onClick={createField}>
						Add Field
					</Button>
				</div>
			}
		</div>
	)
}

Fields.propTypes = {
	groupId: PropTypes.any,
	filters: PropTypes.object.isRequired,
	setShowFieldModal: PropTypes.func.isRequired,
	setUpdate: PropTypes.func.isRequired,
	setFieldToUpdate: PropTypes.func.isRequired
}

export default Fields;
